import { api } from './client';
import type {
  ApplicationLogDto,
  AuditLogDto,
  AuditLogQueryDto,
  LogQueryDto,
  LoginAttemptDto,
  LoginAttemptQueryDto,
  PagedRequest,
  PagedResult,
  WebhookDeliveryDto,
  WebhookSubscriptionDto,
  WebhookSubscriptionUpsertDto,
} from './types';

/* ------------------------------------------------------------------ *
 *  Entegrasyon ve gunlukler — 8 uc
 *  webhook (5), gunlukler (3)
 * ------------------------------------------------------------------ */

export const adminWebhooksApi = {
  /** 1. Kayitli webhook abonelikleri. */
  getAll: () => api.get<WebhookSubscriptionDto[]>('/api/admin/webhooks'),

  /** 2. Abonelik olusturur. Gizli anahtar yalnizca bu yanitta doner. */
  create: (dto: WebhookSubscriptionUpsertDto) =>
    api.post<WebhookSubscriptionDto>('/api/admin/webhooks', dto),

  /** 3. Abonelik gunceller. */
  update: (id: number, dto: WebhookSubscriptionUpsertDto) =>
    api.put<WebhookSubscriptionDto>(`/api/admin/webhooks/${id}`, dto),

  /** 4. Abonelik siler. */
  remove: (id: number) => api.deleteCommand(`/api/admin/webhooks/${id}/delete`),

  /** 5. Gonderim gecmisi: durum kodu, deneme sayisi, hata. */
  deliveries: (id: number, query: PagedRequest = {}) =>
    api.get<PagedResult<WebhookDeliveryDto>>(`/api/admin/webhooks/${id}/deliveries`, query),
};

export const adminLogsApi = {
  /** 6. Uygulama gunlugu (hata, uyari, bilgi). */
  application: (query: LogQueryDto = {}) =>
    api.get<PagedResult<ApplicationLogDto>>('/api/admin/logs/application', query),

  /** 7. Denetim kaydi: kim, ne zaman, neyi degistirdi. */
  audit: (query: AuditLogQueryDto = {}) =>
    api.get<PagedResult<AuditLogDto>>('/api/admin/logs/audit', query),

  /** 8. Giris denemeleri; basarisiz denemeler ve IP'ler. */
  loginAttempts: (query: LoginAttemptQueryDto = {}) =>
    api.get<PagedResult<LoginAttemptDto>>('/api/admin/logs/login-attempts', query),
};
